import {kSystemIcons} from "../../../constants/icons";

export default function BrevetLevelAsFilterButton({onFilterButtonClick, appliedFilters, clearFilters}) {
    // Used in BrevetLevelAsHeader to display filters buttons
    // that open filters modal or clear active filters

    // PROPERTIES
    const count = countAppliedFilters();
    const hasFilters = count > 0;

    // BUILD
    return (
        <div className={"flex items-center"}>
            <div className={"flex items-center"}>
                {/** Filters button */}
                <div className={`cursor-pointer h-[40px] border-[1px] border-greyLight5 bg-greyLight1 hover:bg-greyLight3 flex justify-center items-center px-[12px] py-[2px] space-x-[8px]
                                 ${hasFilters ? "rounded-l-[8px] rounded-r-none border-r-0" : "rounded-[8px]"}`}
                                            onClick={onFilterButtonClick}>
                    <i className={`material-icons text-[24px] mt-[1px] -ml-[2px] ${hasFilters ? "text-greenStar" : "text-white"}`}>
                        {kSystemIcons.filter}
                    </i>
                    <span className="font-bold text-[14px] text-white">
                        <span>
                            Filtres
                        </span>
                        {hasFilters && (<span className="text-greenStar">{` (${count})`}</span>)}
                    </span>
                </div>
                {/** Clear filters potential button */}
                {hasFilters && (
                    <div className={"cursor-pointer h-[40px] border-[1px] border-greyLight5 bg-greyLight1 hover:bg-greyLight3 flex justify-center items-center px-[8px] py-[2px] rounded-r-[8px] rounded-l-none"}
                        onClick={(e) => {
                            e.stopPropagation()
                            clearFilters() }}>
                        <i className={"material-icons text-[20px] text-white"}>
                            {kSystemIcons.close}
                        </i>
                    </div>
                )}
            </div>
        </div>
    );

    // METHODS
    // ---- UX/UI : Check if applied filters is not empty
    function countAppliedFilters() {
        if (!appliedFilters) return 0;
        const subthemesCount = Array.isArray(appliedFilters.subthemes) ? appliedFilters.subthemes.length : 0;
        const gradesCount = Array.isArray(appliedFilters.grades) ? appliedFilters.grades.length : 0;
        const mediaCount = Array.isArray(appliedFilters.media) ? appliedFilters.media.length : 0;
        return subthemesCount + gradesCount + mediaCount;
    }
}